"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ArticleSearchService_1 = __importDefault(require("../Services/Search/ArticleSearchService"));
class ArticleSearch {
    main() {
        ArticleSearchService_1.default.init();
    }
}
exports.default = ArticleSearch;
